const MONTH_ORDER = {'Jan': 1, 'Feb': 2, 'Mar': 3, 'Apr': 4, 'May': 5, 'Jun': 6, 'Jul': 7, 'Aug': 8, 'Sep': 9, 'Oct': 10, 'Nov': 11, 'Dec': 12};
var current_events = {};

function get_month_order(month) {
  return MONTH_ORDER[month[0].slice(0, 3)]
}

function is_before(month_one, month_two) {
  return parseInt(month_one[1]) < parseInt(month_two[1]) || (parseInt(month_one[1]) == parseInt(month_two[1]) && get_month_order(month_one) < get_month_order(month_two));
}

function _format_date(date, as_string) {
  return as_string ? `${date[0]} ${date[1]}` : date;
}

function get_month_date(month_div, as_string=false) {
  return _format_date(month_div.querySelector('span').innerHTML.trim().split(' '), as_string);
}

function get_event_date(list_node, as_string=false) {
  return _format_date(list_node.querySelector('.date').innerHTML.trim().split(' ').slice(0, 2), as_string);
}

function is_current(month) {
  const now = Date().split(' ');
  return (month.slice(0, 3) == now[1] && parseInt(month.split(' ')[1]) == now[3]) ? 'current-month' : '';
}

function today_or_later(day, month) {
  const now = Date().split(' ');
  if (parseInt(month[1]) > parseInt(now[3]))
    return true;
  if (parseInt(month[1]) == parseInt(now[3]) && get_month_order(month) > MONTH_ORDER[now[1]])
    return true;
  if (parseInt(month[1]) == parseInt(now[3]) && get_month_order(month) == MONTH_ORDER[now[1]] && parseInt(day) >= parseInt(now[2]))
    return true;
  return false;
}

function _get_compare_fct(container_id) {
  if (container_id == 'current_events') {
    return function(node, month, day) {
      return true;
    }
  }
  return function(node, month, day) {
    return node.querySelector('.today') || today_or_later(day, month);
  }
}

function collect_events(container) {
  let event_list = {};
  const months = container.querySelectorAll('.month');
  const _compare_fct = _get_compare_fct(container.id);
  for (let i = 0; i < months.length; i++) {
    const month = get_month_date(months[i]);
    const month_str = _format_date(month, true);
    const events = months[i].querySelectorAll('li');
    for (let j = 0; j < events.length; j++) {
      const day = get_event_date(events[j])[1];
      if (_compare_fct(events[j], month, day)) {
        if (month_str in event_list) {
          if (day in event_list[month_str]) {
            event_list[month_str][day].push(events[j]);
          } else {
            event_list[month_str][day] = [events[j]];
          }
        } else {
          event_list[month_str] = {};
          event_list[month_str][day] = [events[j]];
        }
      }
    }
  }
  return event_list;
}

function move_event(node, from_container, to_container, before=null) {
  if (before) {
    to_container.insertBefore(node, before);
  } else {
    to_container.appendChild(node);
  }
  if (from_container.querySelectorAll('li').length === 0) {
    from_container.remove();
  }
}

function make_new_month(month, target_container, events, before=null) {
  const new_month = document.createElement('div');
  new_month.classList.add('month');
  new_month.innerHTML = `<h4 class="${is_current(month)}"><span>${month}</span></h4><ul></ul>`;
  if (before) {
    target_container.insertBefore(new_month, before);
  } else {
    target_container.appendChild(new_month);
  }
  days = Object.keys(events).sort();
  for (let i = 0; i < days.length; i++) {
    events[days[i]].forEach(node => move_event(node, node.parentNode.parentNode, new_month.querySelector('ul')));
  }
  return new_month;
}

function insert_events(event_list, target_container) {
  const months = Object.keys(event_list);
  const month_divs = target_container.querySelectorAll('.month');
  for (let i = 0; i < month_divs.length; i++) {
    const month = get_month_date(month_divs[i]);
    const month_str = _format_date(month, true);
    if (month_str == months[0]) {
      let days = Object.keys(event_list[month_str]).sort();
      const events = month_divs[i].querySelectorAll('li');
      for (let j = 0; j < events.length; j++) {
        if (parseInt(get_event_date(events[j])[1]) >= parseInt(days[0])) {
          event_list[month_str][days[0]].forEach(node => move_event(node, node.parentNode.parentNode, month_divs[i].querySelector('ul'), events[j]));
          days.splice(0, 1);
        }
      }
      while (days.length) {
        event_list[month_str][days[0]].forEach(node => move_event(node, node.parentNode.parentNode, month_divs[i].querySelector('ul')));
        days.splice(0, 1);
      }
      months.splice(0, 1);
    }
    if (is_before(months[0].split(' '), month)) {
      make_new_month(months[0], target_container, event_list[months[0]], month_divs[i]);
      months.splice(0, 1);
      if (months.length) {
        i--;
      }
    }
    if (months.length == 0) {
      return;
    }
  }
  while (months.length) {
    make_new_month(months[0], target_container, event_list[months[0]]);
    months.splice(0, 1);
  }
}

function show_past() {
  document.querySelectorAll('#no-events-msg').forEach(p => p.setAttribute('hidden', 'true'));
  document.querySelector('#past_events_message').setAttribute('hidden', 'true');
  document.querySelector('#past_events').removeAttribute('hidden');
  const toggle_btn = document.querySelector('#toggle_past_events');
  toggle_btn.removeEventListener('click', show_past);
  toggle_btn.addEventListener('click', hide_past);
  toggle_btn.innerHTML = 'Hide';

  current_events = collect_events(document.querySelector('#current_events'));
  insert_events(current_events, document.querySelector('#past_events'));
}

function hide_past() {
  document.querySelectorAll('#no-events-msg').forEach(p => p.removeAttribute('hidden'));
  document.querySelector('#past_events').setAttribute('hidden', 'true');
  document.querySelector('#past_events_message').removeAttribute('hidden');
  const toggle_btn = document.querySelector('#toggle_past_events');
  toggle_btn.removeEventListener('click', hide_past);
  toggle_btn.addEventListener('click', show_past);
  toggle_btn.innerHTML = 'Show';

  insert_events(current_events, document.querySelector('#current_events'));
}

function show_future() {
  document.querySelectorAll('#no-events-msg').forEach(p => p.setAttribute('hidden', 'true'));
  document.querySelector('#future_events_message').setAttribute('hidden', 'true');
  document.querySelector('#future_events').removeAttribute('hidden');
  const toggle_btn = document.querySelector('#toggle_future_events');
  toggle_btn.removeEventListener('click', show_future);
  toggle_btn.addEventListener('click', hide_future);
  toggle_btn.innerHTML = 'Hide';
}

function hide_future() {
  document.querySelectorAll('#no-events-msg').forEach(p => p.removeAttribute('hidden'));
  document.querySelector('#future_events').setAttribute('hidden', 'true');
  document.querySelector('#future_events_message').removeAttribute('hidden');
  const toggle_btn = document.querySelector('#toggle_future_events');
  toggle_btn.removeEventListener('click', hide_future);
  toggle_btn.addEventListener('click', show_future);
  toggle_btn.innerHTML = 'Show';
}

function move_navigation() {
  const navigation = document.querySelector('#navigation-box');
  if (navigation.childElementCount) {
    navigation.parentElement.removeChild(navigation);
    let sidebar = document.querySelector('.category-sidebar');
    if (sidebar === null) {
      sidebar = document.createElement('div');
      sidebar.classList.add('category-sidebar');
      sidebar.style = 'height:1px';
      document.querySelector('.category-container').insertBefore(sidebar, document.querySelector('.category-content-wrapper'));
    }
    document.querySelector('.category-container').insertBefore(navigation, sidebar);
  } else {
    navigation.remove();
  }
}

function scale_navigation_box() {
  const navigation = document.querySelector('#navigation-box');
  const container = document.querySelector('.category-container');
  let width = 340;
  navigation.querySelectorAll('li').forEach(item => {
    while (item.offsetHeight > 50 && navigation.offsetWidth / container.offsetWidth < 0.3) {
      width += 1;
      navigation.style = `width: ${width}px`;
    }
  });
}

function single_line_height() {
  const li = document.querySelector('#navigation-box').querySelector('li');
  li.style = 'white-space: nowrap';
  const height = li.offsetHeight;
  li.style = '';
  return height;
}

function scale_navigation_items() {
  let fontSize = 15;
  const height = single_line_height();
  document.querySelector('#navigation-box').querySelectorAll('li').forEach(item => {
    item.style = `font-size: ${fontSize}px`;
    while (item.offsetHeight > height && fontSize > 1) {
      fontSize -= 1;
      item.style = `font-size: ${fontSize}px`;
    }
  });
  return fontSize;
}

document.addEventListener('DOMContentLoaded', async function() {
  let toggle_btn = document.querySelector('#toggle_past_events');
  if (toggle_btn) {
    toggle_btn.addEventListener('click', show_past);
  }
  toggle_btn = document.querySelector('#toggle_future_events');
  if (toggle_btn) {
    toggle_btn.addEventListener('click', show_future);
  }
  await move_navigation();
  await scale_navigation_box();
  const fontSize = await scale_navigation_items();
  document.querySelector('#navigation-box').querySelectorAll('li').forEach(item => {
    item.style = `font-size: ${fontSize}px`;
  });
});
